import firebase from "firebase/app";
import "firebase/analytics";

const instance = {
    init: () => {
        if (process.env.NODE_ENV === "UI-TEST" || process.env.NODE_ENV === "development")
            return;

        const firebaseConfig = {
            apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
            authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.VUE_APP_FIREBASE_APP_ID,
            measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
        };
        firebase.initializeApp(firebaseConfig);
    },
    getAnalytics: () => {
        if (process.env.NODE_ENV === "UI-TEST" || process.env.NODE_ENV === "development")
            return;

        return firebase.analytics();
    }
};

export default instance;
